export default "__VITE_ASSET__60074a79__"